import ApiBase from './Api'
import { SearchEntity } from 'types/SearchEntity'

const SEARCH_API_PATHS = {
    SEARCH: '/search',
}

class SearchApi extends ApiBase {
    async freeSearch(query: string): Promise<SearchEntity[]> {
        const response = await this._getRequest(SEARCH_API_PATHS.SEARCH, {
            queryParameters: { q: query },
        })

        return response as SearchEntity[]
    }
}

export default SearchApi
